<template>
  <g :transform="transform">
    <Female v-if="type === CARD_TYPES.misses" />
    <Male v-if="type === CARD_TYPES.mister" />
    <Moral v-if="![CARD_TYPES.mister, CARD_TYPES.misses].includes(type)" />
  </g>
</template>

<script>
  import Female from '@/components/common/SvgImage/images/Female'
  import Male from '@/components/common/SvgImage/images/Male'
  import Moral from '@/components/common/SvgImage/images/Moral'

  import { CARD_TYPES } from '@/components/common/RelationCard/RelationCard.const'

  export default {
    components: {
      Female,
      Male,
      Moral,
    },
    props: {
      x: {
        type: Number,
        default: 0,
      },
      y: {
        type: Number,
        default: 0,
      },
      type: {
        type: String,
        default: 'moral',
      },
    },
    data() {
      return {
        CARD_TYPES,
      }
    },
    computed: {
      transform() {
        return `translate(${this.x}, ${this.y})`
      },
    },
  }
</script>
